<template>
  <div>
    <div v-bind:class="isShowingModal ? 'z-50' : 'opacity-0 pointer-events-none'" class="overflow-x-hidden overflow-y-auto fixed inset-0 top-0 left-0 outline-none focus:outline-none justify-center items-center flex">
      <div :class="getCssSize">
        <!--content-->
        <div class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <!--header-->
          <div class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
            <h3 class="text-2xl font-semibold">
              {{ title }}
            </h3>
            <button class="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none" v-on:click="toggleModal()">
              <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                ×
              </span>
            </button>
          </div>
          <!--body-->
          <slot name="body" >
          </slot>
          <!--footer-->
          <div class="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
            <button class="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" v-on:click="toggleModal()">
              Cancel
            </button>
            <button class="bg-blue-700 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    v-on:click="save()">
              {{labelSaveButton}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isShowingModal" class="opacity-25 fixed inset-0 z-40 bg-black"></div>
  </div>
</template>
<script>
export default {
  name: 'ModalDialog',
  props: {
    title: {
      type: String,
      default: '',
    },
    errorMsg: {
      type: String,
      default: '',
    },
    isShowingModal: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    labelSubmit: {
      type: String,
      default: 'Submit for Review',
    },
    size: {
      type: String,
      default: 'regular',
    },
  },
  computed: {
    labelSaveButton() {
      return !this.isLoading ? this.labelSubmit : '';
    },
    getCssSize() {
      let classes = 'relative w-auto my-6 mx-auto max-w-3xl h-full p-10';
      switch (this.size) {
        case 'regular':
          classes = 'relative w-auto my-6 mx-auto max-w-3xl h-full p-10';
          break;
        case 'small':
          classes = 'relative w-auto my-6 mx-auto max-w-sm h-full p-10';
          break;
        case 'large':
          classes = 'relative w-auto my-6 mx-auto max-w-6xl h-full p-10';
          break;
        case 'xlarge':
          classes = 'relative w-3/4 my-6 mx-auto h-full p-10';
          break;
      }
      return classes;
    },
  },
  methods: {
    toggleModal() {
      this.$emit('toggleModal');
    },
    save() {
      this.$emit('save');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Common/ModalDialog.vue